export class TileState<TListModel, TModel> {
  list: TListModel[] = [];
  currentPage = 0;
  totalCount: number = 0;
  loading: boolean = false;
  errors: string[] = [];
  selected: TModel = undefined;
}



// WEBPACK FOOTER //
// ./src/app/pillar/dashboard/store/state/TileState.ts